export const REPUTATION_TABS = [
    { id: 'overview', label: 'Overview', icon: 'bi-speedometer2', theme: 'warning' },
    { id: 'reputation-links', label: 'Reputation Links', icon: 'bi-link-45deg', theme: 'cyan' },
    { id: 'comments', label: 'Patient Comments', icon: 'bi-chat-dots', theme: 'purple' },
    { id: 'feedbacks', label: 'Patient Feedback', icon: 'bi-emoji-smile', theme: 'success' },
];

export const EMPTY_PAGE = { content: [], totalElements: 0, totalPages: 0 };

export const formatReputationDate = (dateString) => {
    if (!dateString) {
        return '—';
    }

    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

export const getCommentStatusMeta = (status) => {
    const statusConfig = {
        SENT: { className: 'reputation-status reputation-status--success', icon: 'bi-check-circle', label: 'Sent', theme: 'success' },
        PENDING: { className: 'reputation-status reputation-status--warning', icon: 'bi-clock', label: 'Pending', theme: 'warning' },
        ERROR: { className: 'reputation-status reputation-status--danger', icon: 'bi-exclamation-triangle', label: 'Error', theme: 'danger' },
    };

    return statusConfig[status] || statusConfig.PENDING;
};

export const getFeedbackMeta = (feedback) => {
    const feedbackIcons = {
        0: { icon: 'bi-emoji-neutral-fill', className: 'reputation-feedback reputation-feedback--neutral', label: 'Neutral', theme: 'warning' },
        1: { icon: 'bi-emoji-angry-fill', className: 'reputation-feedback reputation-feedback--negative', label: 'Negative', theme: 'danger' },
        2: { icon: 'bi-emoji-smile-fill', className: 'reputation-feedback reputation-feedback--positive', label: 'Positive', theme: 'success' },
    };

    return feedbackIcons[feedback] ?? feedbackIcons[0];
};

export const getLinkTypeMeta = (linkType) => {
    const icons = {
        FACEBOOK: { icon: 'bi-facebook', theme: 'primary' },
        WEBSITE: { icon: 'bi-globe', theme: 'cyan' },
        GOOGLE: { icon: 'bi-google', theme: 'success' },
        YELP: { icon: 'bi-star-fill', theme: 'warning' },
        INSTAGRAM: { icon: 'bi-instagram', theme: 'pink' },
    };

    return icons[linkType] || { icon: 'bi-link-45deg', theme: 'slate' };
};

export const getPatientInitials = (firstName = '', lastName = '') =>
    `${firstName.charAt(0) || ''}${lastName.charAt(0) || ''}`.toUpperCase() || '?';

export const getNameInitials = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .map((part) => part.charAt(0))
        .join('')
        .slice(0, 2)
        .toUpperCase() || '?';

export const buildReputationUrl = (shortCode) =>
    shortCode?.shortCode ? `https://eyeconx.com/${shortCode.shortCode}` : '';
